export default __webpack_public_path__ + "static/media/quantsapp-partner.d5b4fd10.svg";